/* Matted – cartes compactes des collections (fichier dédié, indépendant de Dawn).
   - Photo, titre, prix, prix au m² et liens suivent toujours la même variante.
   - Une combinaison inexistante n'est jamais sélectionnée : on propose une bascule explicite.
   - Le choix fait sur une carte est conservé au retour depuis la fiche (sessionStorage, même URL de collection).
   - Tri « Prix au m² » : proposé seulement quand TOUS les résultats filtrés tiennent sur la page
     (data-m2sort="true" calculé en Liquid avec paginate.pages == 1) ; sinon l'option n'apparaît pas.
   Réinitialisé après chaque rafraîchissement des filtres Dawn (MutationObserver). */
(function () {
  function short(s) { return String(s).split(' (')[0]; }
  function vid(u) { var m = /[?&]variant=(\d+)/.exec(u || ''); return m ? m[1] : ''; }
  function list(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' et ' + a[a.length - 1]; }

  function initCard(li) {
    if (li.__mq) return; li.__mq = true;
    var vs = JSON.parse(li.querySelector('[data-mq-variants]').textContent);
    var names = JSON.parse(li.querySelector('[data-mq-names]').textContent);
    var mi = +li.dataset.mi, ci = +li.dataset.ci;
    var hidden = names.map(function (n, i) { return i; }).filter(function (i) { return i !== mi && i !== ci; });
    var first = vid(li.querySelector('[data-mq-link]').getAttribute('href'));
    var cur = vs.filter(function (v) { return vid(v.url) === first; })[0] || vs[0];
    var skey = 'mq:' + location.pathname + location.search + ':' + vs[0].url.split('?')[0] + ':' + first;
    try { var saved = sessionStorage.getItem(skey); if (saved) { var sv = vs.filter(function (v) { return vid(v.url) === saved; })[0]; if (sv) cur = sv; } } catch (e) {}
    function remember(v) { try { sessionStorage.setItem(skey, vid(v.url)); } catch (e) {} }
    var sel = cur.o.slice();
    var notice = li.querySelector('[data-mq-notice]');
    var isLot = /le lot/.test((li.querySelector('[data-mq-sub]') || {}).textContent || '');

    function find(s) { return vs.filter(function (v) { return v.o.every(function (o, j) { return o === s[j]; }); })[0]; }
    function say(html) { if (!notice) return; notice.innerHTML = html || ''; notice.hidden = !html; }

    function render(v) {
      cur = v; sel = v.o.slice();
      var im = li.querySelector('[data-mq-image]');
      if (im && v.img) {
        // srcset aligné sur matted-card-compact.liquid (mêmes URL, seul le paramètre width change)
        if (im.hasAttribute('srcset')) im.srcset = [150, 220, 300, 450, 600, 700].map(function (w) { return v.img.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
        im.src = v.img;
      }
      li.querySelectorAll('[data-mq-link]').forEach(function (a) { a.href = v.url; });
      var main = li.querySelector('[data-mq-main]'), sub = li.querySelector('[data-mq-sub]');
      if (v.u) { main.textContent = v.u + '/m²'; sub.textContent = 'soit ' + v.p + (isLot ? ' le lot' : ' la dalle'); }
      else { main.textContent = v.p; if (sub) sub.textContent = ''; }
      var selEl = li.querySelector('[data-mq-sel]');
      if (selEl) {
        var parts = [];
        if (mi >= 0) parts.push(short(sel[mi]));
        if (ci >= 0) parts.push(sel[ci]);
        hidden.forEach(function (h) {
          if (names[h] === 'Title') return;
          parts.push(names[h] === 'Couleur granulat' ? 'granulat ' + String(sel[h]).toLowerCase() : short(sel[h]));
        });
        selEl.textContent = parts.join(' · ');
      }
      var from = li.querySelector('[data-mq-from]');
      if (from) {
        var shown = v.u ? v.u + '/m²' : v.p;
        from.textContent = (from.dataset.min && from.dataset.min !== shown) ? 'À partir de ' + from.dataset.min + ' ' + from.dataset.why : '';
      }
      li.querySelectorAll('.mq-motif,.mq-sw').forEach(function (b) {
        var i = +b.dataset.i, val = b.dataset.v, s = sel.slice(); s[i] = val;
        var on = sel[i] === val, ok = !!find(s);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('mq-na', !ok);
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
        b.title = short(val) + (ok ? '' : ' — non disponible avec la sélection actuelle');
        if (on && b.classList.contains('mq-extra')) b.classList.remove('mq-hidden');
      });
    }

    function choose(i, val) {
      var s = sel.slice(); s[i] = val;
      var v = find(s);
      if (v) { say(''); render(v); remember(v); return; }
      var other = (i === mi) ? ci : mi;
      var offers = [];
      // 1) même version, autre motif/couleur
      if (other >= 0) {
        var a = vs.filter(function (x) { return x.o[i] === val && hidden.every(function (h) { return x.o[h] === sel[h]; }); })[0];
        if (a) offers.push({ v: a, label: 'Voir ' + short(val) + ' en ' + short(a.o[other]) });
      }
      // 2) même motif/couleur, autre version
      var b2 = vs.filter(function (x) { return x.o[i] === val && (other < 0 || x.o[other] === sel[other]); })[0];
      if (b2) {
        var ch = hidden.filter(function (h) { return b2.o[h] !== sel[h]; }).map(function (h) { return short(b2.o[h]); });
        if (ch.length) offers.push({ v: b2, label: 'Disponible en ' + list(ch) });
      }
      var ctx = [];
      if (other >= 0) ctx.push(short(sel[other]));
      hidden.forEach(function (h) { if (names[h] === 'Conception') ctx.push('version ' + short(sel[h])); else if (names[h] !== 'Title') ctx.push(short(sel[h])); });
      var html = '« ' + short(val) + ' » n’existe pas en ' + ctx.join(', ') + '.';
      if (offers.length) {
        html += '<span class="mq-offers">' + offers.map(function (o, k) { return '<button type="button" class="mq-offer" data-k="' + k + '">' + o.label + '</button>'; }).join('') + '</span>';
      }
      say(html);
      notice.querySelectorAll('.mq-offer').forEach(function (btn) {
        btn.addEventListener('click', function () { say(''); render(offers[+btn.dataset.k].v); remember(offers[+btn.dataset.k].v); });
      });
    }

    li.querySelectorAll('.mq-motif,.mq-sw').forEach(function (b) {
      b.addEventListener('click', function () { choose(+b.dataset.i, b.dataset.v); });
    });
    li.querySelectorAll('[data-mq-more]').forEach(function (m) {
      if (!m.dataset.label) m.dataset.plus = m.textContent;
      m.addEventListener('click', function () {
        var box = m.parentNode, open = m.getAttribute('aria-expanded') === 'true';
        box.querySelectorAll('.mq-extra').forEach(function (x) { if (!x.classList.contains('is-on')) x.classList.toggle('mq-hidden', open); });
        m.setAttribute('aria-expanded', open ? 'false' : 'true');
        m.textContent = m.dataset.label ? (open ? m.dataset.label : 'Moins de couleurs') : (open ? m.dataset.plus : 'Moins');
      });
    });
    render(cur);
  }

  /* ---------- Tri « Prix au m² » (uniquement si tous les résultats filtrés sont sur la page) ---------- */
  function currentSort() { return new URLSearchParams(location.search).get('sort_by') || ''; }
  function sortGrid() {
    var grid = document.querySelector('#product-grid.mq-cards');
    if (!grid || grid.dataset.m2sort !== 'true') return;
    var s = currentSort(); if (s !== 'm2-ascending' && s !== 'm2-descending') return;
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li[data-mq-card]'));
    items.sort(function (a, b) {
      var x = parseFloat(a.dataset.m2), y = parseFloat(b.dataset.m2);
      if (isNaN(x)) return 1; if (isNaN(y)) return -1;
      return s === 'm2-ascending' ? x - y : y - x;
    });
    var current = Array.prototype.slice.call(grid.querySelectorAll(':scope > li[data-mq-card]'));
    if (items.every(function (li, k) { return current[k] === li; })) return;
    items.forEach(function (li) { grid.appendChild(li); });
  }
  function patchSortSelects() {
    var grid = document.querySelector('#product-grid.mq-cards');
    if (!grid || grid.dataset.m2sort !== 'true') return;
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      if (sel.__mq) return; sel.__mq = true;
      sel.querySelectorAll('option').forEach(function (o) {
        if (o.value === 'price-ascending') o.textContent = 'Prix unitaire (dalle ou lot), croissant';
        if (o.value === 'price-descending') o.textContent = 'Prix unitaire (dalle ou lot), décroissant';
      });
      [['m2-ascending', 'Prix au m², croissant'], ['m2-descending', 'Prix au m², décroissant']].forEach(function (d) {
        var o = document.createElement('option'); o.value = d[0]; o.textContent = d[1];
        var ref = sel.querySelector('option[value="price-ascending"]');
        sel.insertBefore(o, ref || null);
      });
      var s = currentSort(); if (s.indexOf('m2-') === 0) sel.value = s;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mq-card]').forEach(initCard);
    patchSortSelects();
    sortGrid();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  new MutationObserver(function () { initAll(); }).observe(document.documentElement, { childList: true, subtree: true });
})();